module.exports = __webpack_public_path__ + "img/shipo-icon-weather-sunny.2bbd2cf6.svg";